import { QEmptyState, QStack } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';

export const TrainingAssessmentErrorState = () => {
  const { t } = useTranslation();

  return (
    <QStack
      data-cy="training-assessment-error-state"
      align="center"
      marginTop="100"
      width="full"
    >
      <QEmptyState
        subtitle={t('errors.refreshPageOrContactSupport')}
        title={t('errors.unableToLoadTab')}
      />
    </QStack>
  );
};
